import { AUDIT_ACTIONS } from "./audit.types";
import type { AuditAction, AuditFilterOption } from "./audit.types";

/**
 * Rótulos só das opções do filtro Alteração: a Ação de cada linha vem do serviço (`acaoDescricao`). Duplicados do core
 * até existir um catálogo de ações lá; os textos ainda não foram aprovados pela PO (pendência da HU 744, task 2669).
 */
export const AUDIT_ACTION_LABELS: Record<AuditAction, string> = {
  USUARIO_CRIADO: "Usuário criado",
  USUARIO_ATUALIZADO: "Usuário atualizado",
  USUARIO_PERFIL_ATUALIZADO: "Perfil do usuário atualizado",
  USUARIO_STATUS_ATUALIZADO: "Status do usuário atualizado",
  PERFIL_CRIADO: "Perfil criado",
  PERFIL_ATUALIZADO: "Perfil atualizado",
  PERFIL_EXCLUIDO: "Perfil excluído",
  PERMISSAO_ATUALIZADA: "Permissão atualizada",
  EXPORTACAO: "Exportação",
  IMPRESSAO: "Impressão",
  FICHA_FINANCEIRA_ANEXO_INCLUIDO: "Ficha financeira anexo incluído",
  FICHA_FINANCEIRA_GERADA: "Ficha financeira gerada",
};

/** Filtro Alteração: o rótulo na tela e o código na consulta. */
export const AUDIT_ACTION_OPTIONS: AuditFilterOption[] = AUDIT_ACTIONS.map((value) => ({
  value,
  label: AUDIT_ACTION_LABELS[value],
}));
